import { Button, Dropdown, DropdownItem, DropdownMenu, DropdownTrigger } from '@heroui/react';
import i18n from '@/i18n/config';
import { RiListCheck3, RiArrowDownSLine } from '@remixicon/react';

export interface ColumnsToggleDropdownProps {
  allColumns: { uid: string; name: string }[];
  selected: Set<string>;
  onChange: (next: Set<string>) => void;
}

export function ColumnsToggleDropdown(props: ColumnsToggleDropdownProps) {
  const { allColumns, selected, onChange } = props;

  return (
    <Dropdown size="sm">
      <DropdownTrigger>
        <Button
          className="h-12"
          startContent={<RiListCheck3 className="h-4 w-4" />}
          endContent={<RiArrowDownSLine className="h-4 w-4" />}
          variant="flat"
        >{i18n.t('table.columns')}</Button>
      </DropdownTrigger>
      <DropdownMenu
        disallowEmptySelection
        aria-label={i18n.t('table.toggleColumns')}
        closeOnSelect={false}
        selectedKeys={selected as any}
        selectionMode="multiple"
        onSelectionChange={(keys) => onChange(new Set(keys as any))}
      >
        {allColumns.map((col) => (
          <DropdownItem key={col.uid}>{col.name}</DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
}

export default ColumnsToggleDropdown;
